export default __webpack_public_path__ + "static/media/logo.44e794e2.png";